import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-neev-employee-sports-meet',
  templateUrl: './neev-employee-sports-meet.component.html',
  styleUrls: ['./neev-employee-sports-meet.component.scss']
})
export class NeevEmployeeSportsMeetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
